import { Tag, type TagProps } from '@chakra-ui/react'

export default function LiveNowTag({
  size = 'sm',
  backgroundColor = 'yellow.solid',
  customText = 'Live now!',
}: {
  size?: TagProps['size']
  backgroundColor?: TagProps['backgroundColor']
  customText?: string
}): React.ReactElement {
  return (
    <Tag
      variant="solid"
      backgroundColor={backgroundColor}
      color="yellow.contrast"
      fontWeight="bold"
      mr={1}
      size={size}
      textTransform="uppercase"
      whiteSpace="nowrap"
    >
      {customText}
    </Tag>
  )
}
